<template>
    <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g id="7123025_logo_google_g_icon 1">
            <g id="Group">
                <path
                    id="Vector"
                    d="M19.9498 12.1755C19.9498 11.6795 19.9018 11.1675 19.8218 10.6875H12.8938V13.5195H16.8618C16.7018 14.4315 16.1738 15.2315 15.3898 15.7435L17.7578 17.5835C19.1498 16.2875 19.9498 14.3995 19.9498 12.1755Z"
                    fill="#4280EF"
                />
                <path
                    id="Vector_2"
                    d="M12.8957 19.3458C14.8797 19.3458 16.5437 18.6898 17.7597 17.5698L15.3917 15.7458C14.7357 16.1938 13.8877 16.4498 12.8957 16.4498C10.9757 16.4498 9.35969 15.1538 8.76769 13.4258L6.33569 15.2978C7.58369 17.7778 10.1117 19.3458 12.8957 19.3458Z"
                    fill="#34A353"
                />
                <path
                    id="Vector_3"
                    d="M8.76717 13.4071C8.46318 12.4951 8.46318 11.5031 8.76717 10.5911L6.33518 8.70312C5.29518 10.7831 5.29518 13.2311 6.33518 15.2951L8.76717 13.4071Z"
                    fill="#F6B704"
                />
                <path
                    id="Vector_4"
                    d="M12.8957 7.56853C13.9357 7.55253 14.9597 7.95253 15.7117 8.67253L17.8077 6.56053C16.4797 5.31253 14.7197 4.64053 12.8957 4.65653C10.1117 4.65653 7.58369 6.22453 6.33569 8.70453L8.76769 10.5925C9.35969 8.84853 10.9757 7.56853 12.8957 7.56853Z"
                    fill="#E54335"
                />
            </g>
        </g>
    </svg>
</template>
